import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import Text from '../../input_fields/Text.jsx';
import SaveButton from '../../buttons/SaveButton.jsx';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ForgotPasswordSchema } from './ValidationSchema.js';
import { forgotPasswordTodo } from '../../../redux/slice/ForgotPassword.js';
import { LuRefreshCw } from 'react-icons/lu';


export default function ForgotPasswordForm() {

    const [spinner, setSpinner] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const initialValues = {
        email: "",
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: ForgotPasswordSchema,

        onSubmit: (values, action) => {
            if (!captchaInput.trim()) {
                setCaptchaError('Please enter CAPTCHA');
                return;
            }
            if (captchaInput !== captchaText) {
                setCaptchaError('Captcha Mismatch');
                refreshCaptcha();
                return;
            }
            setSpinner(true);
            dispatch(forgotPasswordTodo({ values })).then((res) => signup_res(res.payload));
        }
    });

    const signup_res = (res, action) => {
        console.log("res",res)
        if (res?.status == 200 || res?.status == 201) {
            toast.success(res?.data?.message, { position: "bottom-right" })
            setTimeout(() => {
                navigate('/otp-verify', { state: { email: res?.data?.data?.[0]?.email, from: location.pathname } });
            }, 1500);
            setSpinner(false)
        }
        else if (res?.status == 404) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        } else if (res?.status == 500) {
            setSpinner(false)
            toast.error("Server error!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }

    // CAPTCHA FUNCTION 
    function generateCaptchaText(length = 5) {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'
        let text = ''
        for (let i = 0; i < length; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return text
    }
    function drawCaptcha(canvas, text) {
        if (!canvas) return
        const ctx = canvas.getContext('2d')
        const w = canvas.width
        const h = canvas.height

        // Background
        ctx.fillStyle = '#f0f4f8'
        ctx.fillRect(0, 0, w, h)

        // Noise lines
        for (let i = 0; i < 5; i++) {
            ctx.strokeStyle = `hsl(${Math.random() * 360}, 40%, 70%)`
            ctx.lineWidth = 1
            ctx.beginPath()
            ctx.moveTo(Math.random() * w, Math.random() * h)
            ctx.lineTo(Math.random() * w, Math.random() * h)
            ctx.stroke()
        }

        // Noise dots
        for (let i = 0; i < 30; i++) {
            ctx.fillStyle = `hsl(${Math.random() * 360}, 40%, 65%)`
            ctx.beginPath()
            ctx.arc(Math.random() * w, Math.random() * h, 1.5, 0, Math.PI * 2)
            ctx.fill()
        }

        // Draw each character with slight rotation
        const fontSize = 28
        ctx.font = `bold ${fontSize}px 'Courier New', monospace`
        ctx.textBaseline = 'middle'
        const startX = 18
        const spacing = (w - 36) / text.length

        for (let i = 0; i < text.length; i++) {
            ctx.save()
            const x = startX + i * spacing
            const y = h / 2 + (Math.random() * 8 - 4)
            const angle = (Math.random() - 0.5) * 0.4
            ctx.translate(x, y)
            ctx.rotate(angle)
            ctx.fillStyle = `hsl(${200 + Math.random() * 60}, 60%, 35%)`
            ctx.fillText(text[i], 0, 0)
            ctx.restore()
        }
    }

    const canvasRef = useRef(null)
    const [captchaText, setCaptchaText] = useState('')
    const [captchaInput, setCaptchaInput] = useState('')
    const [captchaError, setCaptchaError] = useState('')

    const refreshCaptcha = useCallback(() => {
        const newText = generateCaptchaText()
        setCaptchaText(newText)
        setCaptchaInput('')
        drawCaptcha(canvasRef.current, newText)
    }, [])

    useEffect(() => {
        refreshCaptcha()
    }, [refreshCaptcha])

    // Re-draw when captchaText changes and canvas is ready
    useEffect(() => {
        if (canvasRef.current && captchaText) {
            drawCaptcha(canvasRef.current, captchaText)
        }
    }, [captchaText])

    return (
        <>
            <Form onSubmit={(e) => {
                e.preventDefault();
                if (!captchaInput.trim()) {
                    setCaptchaError('Please enter CAPTCHA');
                    return;
                }
                if (captchaInput !== captchaText) {
                    setCaptchaError('Captcha Mismatch');
                    refreshCaptcha();
                    return;
                }
                setCaptchaError('');
                handleSubmit();
            }}>
                <div className="">
                    <div className='container-fluid'>
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="mb-4 biolink-title-gradient " >Forgot Password...!!</h2>
                            </div>
                            <div className="col-md-12">
                                <Text
                                    label_name={"Email"}
                                    placeholder='Enter your email address'
                                    disabled={false}
                                    name='email'
                                    value={values.email || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.email && touched.email ? (<span className='text-danger form_label'>{errors.email}</span>) : null}
                                />
                            </div>

                            <div className="login-input-group">
                                <label>CAPTCHA</label>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '8px',
                                }}>
                                    <canvas
                                        ref={canvasRef}
                                        width={180}
                                        height={48}
                                        style={{
                                            borderRadius: '8px',
                                            border: '1px solid #e5e7eb',
                                        }}
                                    />
                                    <button
                                        type="button"
                                        onClick={refreshCaptcha}
                                        title="Refresh CAPTCHA"
                                        style={{
                                            background: 'none',
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '8px',
                                            padding: '8px',
                                            cursor: 'pointer',
                                            color: '#6b7280',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        <LuRefreshCw size={18} />
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Enter CAPTCHA"
                                    value={captchaInput}
                                    onChange={(e) => {
                                        setCaptchaInput(e.target.value)
                                        setCaptchaError('')
                                    }}
                                    autoComplete="off"
                                    className="form-control form_input"
                                />
                                {captchaError && (
                                    <span className='text-danger' style={{ fontSize: '12px' }}>{captchaError}</span>
                                )}
                            </div>

                            <div className='d-flex justify-content-center mt-2'>
                                <SaveButton
                                    spinner={spinner}
                                    button_name={'SEND OTP'}
                                />
                            </div>
                           
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}
